import ReactDOM from "react-dom/client";
import App from "pages/App";
import {
  ActionIcon,
  Loader,
  MantineProvider,
  MantineTheme,
  MantineThemeOverride,
} from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import { store } from "configs/configureStore";
import { DatesProvider } from "@mantine/dates";
import "dayjs/locale/vi";
import { SWRConfig } from "swr";
import { request } from "apis/base";
import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/core/styles.layer.css";
import "mantine-datatable/styles.layer.css";
import { AppModalProvider } from "utils/providers/AppModalProvider";
import { logout } from "redux/auth/slice";
import { reportErrorToBoundary } from "components/error/ErrorBoundary";

const theme: MantineThemeOverride = {
  primaryColor: "indigo",
  defaultRadius: "md",
  focusRing: "auto",
  fontFamily: "Open Sans, sans-serif",
  headings: { fontFamily: "Open Sans, sans-serif" },
  components: {
    InputWrapper: {
      styles: (theme: MantineTheme) => ({
        label: {
          fontWeight: 500,
        },
      }),
    },
    ActionIcon: ActionIcon.extend({
      defaultProps: {
        variant: "subtle",
      },
    }),
    Loader: Loader.extend({
      defaultProps: {
        type: "bars",
      },
    }),
  },
};

const fetcher = (url: string) => request(url).then((res) => res.data);

// Khi interceptor bắt được 401 và không thể refresh token, nó fire event này
// thay vì window.location.href (gây full page reload làm saga bị kill)
window.addEventListener("auth:logout", () => {
  store.dispatch(logout());
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <MantineProvider defaultColorScheme="light" theme={theme}>
        <SWRConfig
          value={{
            fetcher,
            onError: (error) => {
              const e = error as Record<string, unknown>;
              const res = e?.response as Record<string, unknown> | undefined;
              const status = (e?.status ?? e?.statusCode ?? res?.status) as number | undefined;
              if (status === 403 || (typeof status === "number" && status >= 500)) {
                reportErrorToBoundary(error);
              }
            },
            refreshInterval: 5000,
          }}
        >
          <AppModalProvider>
            <DatesProvider settings={{ locale: "vi" }}>
              <App />
            </DatesProvider>
          </AppModalProvider>
        </SWRConfig>
        <Notifications autoClose={10000} position="top-right" />
      </MantineProvider>
    </BrowserRouter>
  </Provider>,
);

reportWebVitals();
